export default __webpack_public_path__ + "static/cafe_36084-75baabb9eba5d3bc716718779d2aba0e.png";